import React, { useState, useEffect } from "react";
import { Visibility } from "semantic-ui-react";
import _ from "lodash";
import cx from "classnames";

import styles from "./infinite_scroll.module.scss";

export default function InfiniteScroll({
  children,
  loading,
  setPage,
  currentPage,
  totalPages,
  pagination,
  className
}) {
  const [height, setHeight] = useState(0);
  const [initialised, setInitialised] = useState(false);
  const [visibile, setVisible] = useState(false);

  useEffect(() => {
    if (visibile && !initialised) {
      setInitialised(true);
    }
  }, [visibile]);

  const handleVisibility = (e, { calculations }) => {
    setHeight(calculations.height + 100);

    if (calculations.onScreen) {
      setVisible(true);
    }

    if (calculations.bottomPassed && !loading && initialised) {
      const nextPage = currentPage + 1;
      const totalPage = totalPages;
      const paginate = pagination && nextPage > 0 && nextPage <= totalPage;
      if (paginate) {
        setPage(nextPage);
      }
    }
  };

  return (
    <Visibility
      className={cx(styles.infiniteLoader, className)}
      updateOn="repaint"
      fireOnMount
      once
      offset={height}
      onUpdate={handleVisibility}
    >
      {children}
    </Visibility>
  );
}
